<template>
	<div>
		<template v-if="isEditable && editing" v-for="(day, idx) in venueHours">
			<v-row :key="`row-${day.day}`">
				<v-col cols="12">
					<v-row no-gutters>
						<v-col align-self="start" order="last" order-sm="start">
							<div class="font-weight-bold text-body-2" style="margin-top: 10px;">
								{{ day.label }}
							</div>
						</v-col>
						<v-col
							align-self="start"
							class="align-center d-flex"
							cols="auto"
							order="start"
							order-sm="last"
						>
							<v-switch
								v-model="day.selected"
								class="mt-0 pt-0"
								dense
								:disabled="!isEditable"
								hide-details="auto"
								inset
								style="margin-top: 4px;"
							></v-switch>
							<v-btn color="secondary" icon @click="makeOpen24H(idx)" :disabled="!isEditable">
								<v-icon>mdi-hours-24</v-icon>
							</v-btn>
						</v-col>
					</v-row>
					<v-row v-if="day.selected && isEditable" class="mt-0" no-gutters>
						<v-col align-self="start">
							<v-divider class="mb-1"></v-divider>
							<div class="align-center d-flex justify-space-between">
								<div class="font-weight-medium text-caption">
									<v-icon x-small>mdi-content-copy</v-icon>
									Copy To:
								</div>
								<div>
									<v-btn
										aria-label="Apply All"
										class="ms-2"
										color="secondary"
										depressed
										outlined
										x-small
										@click="copyTo(idx, true)"
									>
										All Days
									</v-btn>
									<v-btn
										aria-label="Apply All"
										class="ms-2"
										color="secondary"
										depressed
										outlined
										x-small
										@click="copyTo(idx)"
									>
										{{ [0, 6].includes(idx) ? 'Weekend' : 'Weekdays' }}
									</v-btn>
								</div>
							</div>
						</v-col>
					</v-row>
					<v-row md="8"  style="margin-top: 0">
						<v-col :cols="day.selected ? 12 : 5">
							<v-row>
								<v-col align-self="start" cols="6">
									<bw-time-input
										v-if="day.selected"
										v-model="day.openTime"
										class="rounded-lg required"
										:disabled="!isEditable"
										label="Open Time"
										outlined
										required
									></bw-time-input>
									<div
										v-else
										class="text-body-2 text--disabled"
										style="margin-top: -6px;"
									>
										Closed
									</div>
								</v-col>
								<v-col v-if="day.selected" align-self="start" cols="6">
	
									<bw-time-input
										v-if="day.selected"
										v-model="day.closeTime"
										class="rounded-lg required"
										:disabled="!isEditable"
										label="Close Time"
										outlined
										required
									></bw-time-input>
	
								</v-col>
	
							</v-row>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-divider v-if="idx < 6" class="opacity-40"></v-divider>
		</template>
		<v-row v-if="!editing" v-for="(day, idx) in venueHours" :key="`row-${day.day}`">
					<v-col align-self="start" order-sm="start" cols="3" md="2" style="padding: 2px 16px;">
						<div class="font-weight-bold text-body-2">
							{{ day.label }}
						</div>
					</v-col>
					<v-col align-self="start" style="padding: 2px 16px;">
						{{ dayToText(day) }}
					</v-col>
		</v-row>
		<v-row v-if="!isEditable">
			<v-col class="text-start">
				<v-btn

					color="primary"
					@click="getBusinessHours"
					:loading="loading"
				>
					<span class="mr-2">REFRESH BUSINESS HOURS</span>
					<v-icon rigth>mdi-refresh</v-icon>
				</v-btn>
				<div style="padding: 8px 0px;" >
					{{venue.place_last_refreshed_at ? `Refreshed: ${formatDate(venue.place_last_refreshed_at)}` : ''}}
				</div>
			</v-col>
			
		</v-row>
		<v-row v-if="isEditable && !editing" class="mt-4">
			<v-col>
				<v-col class="text-start">
					<v-btn

						color="primary"
						@click="editing = true"
						:loading="loading"
					>
						EDIT
					</v-btn>
				</v-col>
			</v-col>
		</v-row>
		<v-row v-if="isEditable && editing" class="mt-4">
			<v-col>
				<v-col class="text-start">
					<v-btn

						color="primary"
						@click="editing = false"
						:loading="loading"
					>
						CLOSE
					</v-btn>
				</v-col>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	name: 'BusinessHours',
	props: {
		placeIdField: String,
		venue: {
			type: Object,
			default: () => ({})
		},
		updateEndpoint: String,
	},
	data() {
		return {
			days: [
				'Sunday',
				'Monday',
				'Tuesday',
				'Wednesday',
				'Thursday',
				'Friday',
				'Saturday'
			],
			editing: false,
			formIsValid: false,
			loading: false,
			venueHours: [],
		};
	},
	mounted() {
		this.setHours();
	},
	computed: {
		isEditable() {
			return !this.venue[this.placeIdField];
		}
	},
	methods: {
		copyTo(idx, copyAll) {
			const copyFrom = this.venueHours[idx];
			let dayArr;

			if(copyAll) {
				dayArr = [0, 1, 2, 3, 4, 5, 6];
			}
			else if([0, 6].includes(idx)) {
				dayArr = [0, 6].filter(i => i !== idx);
			}
			else if(idx > 0 && idx < 6) {
				dayArr = [1, 2, 3, 4, 5].filter(i => i !== idx);
			}

			this.$set(this.$data, 'venueHours', this.venueHours.map((hours, i) => {
				const shouldCopy = dayArr.includes(i);

				return {
					...hours,
					closeTime: shouldCopy ? copyFrom.closeTime : hours.closeTime,
					openTime: shouldCopy ? copyFrom.openTime : hours.openTime,
					selected: hours.selected || shouldCopy
				};
			}));
		},
		
		dayToText(day) {
			if((!day.openTime || day.openTime === '') && (!day.closeTime || day.closeTime === '')) return 'Closed';
			if(day.openTime === '0000' && day.closeTime === '0000') return 'Open 24 hours';
			//format 0000 to 00:00
			if(Array.isArray(day.dayHours)) {
				return day.dayHours.map(day => {
					const open = moment(day.openTime, 'HHmm').format('h:mm A');
					const close = moment(day.closeTime, 'HHmm').format('h:mm A');
					return `${open} - ${close}`;
				}).join(', ');
			}
			const open = moment(day.openTime, 'HHmm').format('h:mm A');
			const close = moment(day.closeTime, 'HHmm').format('h:mm A');
			return `${open} - ${close}`;
		},

		formatDate(date) {
			return moment.utc(date).tz(moment.tz.guess()).format('MMMM Do, [at] h:mm A');
		},

		getDayHours(idx, day) {
			if(this.isDayClosed(idx, day) || !this.venue.hours?.weekday_text) return {};

			const periods = (this.venue.hours.periods || []).filter(x => x.open?.day === idx);
			if(!periods.length) return {};
			if(periods.length === 1 && !periods[0]?.close && periods[0]?.open?.time === '0000') return {};
			if(periods.length === 1) {
				const period = (this.venue.hours.periods || []).find(x => x.open?.day === idx);
				if (!period) return {};

				return {
					open: moment(period.open.time, 'HHmm').format('h:mm A'),
					openTime: period.open.time,
					close: moment(period.close.time, 'HHmm').format('h:mm A'),
					closeTime: period.close.time
				};
			} else {
				return periods.map(period => ({
					open: moment(period.open.time, 'HHmm').format('h:mm A'), // texto 9:00 AM, etc.
					openTime: period.open.time,                             // 0900 (string)
					close: moment(period.close.time, 'HHmm').format('h:mm A'),
					closeTime: period.close.time
				}));
			}
		},
		
		getBusinessHours() {
			this.loading = true;
			this.axios
				.post(this.updateEndpoint)
				.then(({ data: { hours, place_last_refreshed_at } }) => {
					this.venue.hours = hours;
					this.venue.place_last_refreshed_at = place_last_refreshed_at;
					this.setHours();
				})
				.catch(error => {
					if (error.response) {
						window.EventBus.$emit('system-messages', [
							{
								message: error.response.data.message,
								messageType: 'error',
								showOverlay: true
							}
						]);
					}
				})
				.finally(() => {
					this.loading = false;
				});
			
			this.loading = false;
		},

		isDayClosed(idx, dayName) {
			const dayText = this.venue.hours?.weekday_text?.find(text => text.startsWith(dayName));
			if (!dayText) return true;
			return /(^$)|(?=Closed)/.test(dayText);
		},

		makeOpen24H(idx) {
			this.$set(this.venueHours, idx, {
				...this.venueHours[idx],
				closeTime: '0000',
				openTime: '0000',
				selected: true
			});
		},

		open247() {
			const { periods = [] } = this.venue?.hours || {};
			return periods.length === 1 && !periods[0]?.close && periods[0]?.open?.time === '0000';
		},

		setHours() {
			this.venueHours = this.days.map((day, idx) => {
				if (this.open247())
					return {
						close: '12:00 AM',
						closeTime: '0000', // '22:00'
						day: idx,
						label: day,
						menu1: false,
						menu2: false,
						open: '12:00 AM',
						openTime: '0000',
						selected: true
					};
				const dayHours = this.getDayHours(idx, day) || {};
				return {
					close: dayHours?.close || dayHours[dayHours.length-1]?.close || '', // '10:00 PM'
					closeTime: dayHours?.closeTime || dayHours[dayHours.length-1]?.closeTime || '', // '22:00'
					day: idx,
					label: day,
					menu1: false,
					menu2: false,
					open: dayHours?.open || dayHours[0]?.open || '', // '7:00 AM'
					openTime: dayHours?.openTime || dayHours[0]?.openTime || '', // '07:00'
					selected: !this.isDayClosed(idx, day),
					dayHours
				};
			});
		},
	},
	watch: {
		venueHours: {
			deep: true,
			handler: function (newHours) {
				this.$set(this.venue, 'hours', {
					periods:
							newHours
									.filter(newHour => newHour.selected)
									.map(newHour => ({
										open: {
											day: newHour.day,
											time: newHour.openTime // 1030
										},
										close: {
											day: newHour.day,
											time: newHour.closeTime // 2030
										}
									})),

					// Monday: 10:25 AM - 8:25 PM
					// Tuesday: Closed
					weekday_text:
							newHours.map(newHour => {
								if(!newHour.selected) return `${newHour.label}: Closed`;
								if(newHour.openTime === '' && newHour.closeTime === '') return `${newHour.label}: Closed`;
								if(newHour.openTime === newHour.closeTime) return `${newHour.label}: Open 24 hours`;
								const open = moment(newHour.openTime, 'HHmm').format('h:mm A');
								const close = moment(newHour.closeTime, 'HHmm').format('h:mm A');
								return `${newHour.label}: ${open} - ${close}`;
							})
				})
			}
		}
	}
};
</script>

<style lang="scss" scoped></style>